var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-previous-video-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-previous-video-detail__withData",attrs:{"value":_vm.currentVideo},on:{"deleteVideo":_vm.toDeleteVideo}})}
var staticRenderFns = []

export { render, staticRenderFns }